import React, { Fragment, useState } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import axios from "axios";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import { setAlert } from "../../../actions/alert";

import "react-datepicker/dist/react-datepicker.css";
import RedLogo from "../Mentors/RedLogo";
import Alert from "./Alert";
import GreenLogo from "../Innovators/GreenLogo";

const RedSpinner =
  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Red_Spinner.gif";

const CardField = ({ onChange }) => (
  <div className="FormRow">
    <CardElement
      className="sub-input"
      onChange={onChange}
      options={CARD_OPTIONS}
    />
  </div>
);

const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#FFF",
      color: "#fff",
      fontWeight: 500,
      fontFamily: "Krub, sans-serif",
      fontSize: "14px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": {
        color: "#fce883",
      },
      "::placeholder": {
        color: "#FFF",
      },
    },
    invalid: {
      iconColor: "#ffc7ee",
      color: "#ffc7ee",
    },
  },
};

const Field = ({
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="FormRow">
    <input
      className="sub-input"
      id={id}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const FieldUserName = ({
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="FormRow">
    <input
      className="sub-input"
      id={id}
      minLength={3}
      maxLength={15}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const FieldFirstLastName = ({
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="FormRow">
    <input
      className="sub-input"
      id={id}
      maxLength={30}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const FieldEmail = ({
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="FormRow">
    <input
      className="sub-input"
      id={id}
      maxLength={100}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const FieldJobTitleStateCity = ({
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="FormRow">
    <input
      className="sub-input"
      id={id}
      maxLength={50}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const FieldPasswords = ({
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="FormRow">
    <input
      className="sub-input"
      id={id}
      minLength={7}
      maxLength={20}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const SubmitButton = ({ processing, error, children, disabled }) => (
  <button
    className={`purchase-sub background-red bold ${
      error ? "SubmitButton--error" : ""
    }`}
    type="submit"
    disabled={processing || disabled}
  >
    {processing ? "Processing..." : children}
  </button>
);

const ErrorMessage = ({ children }) => (
  <div className="ErrorMessage white" role="alert">
    <svg width="16" height="16" viewBox="0 0 17 17">
      <path
        fill="#FFF"
        d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
      />
      <path
        fill="#6772e5"
        d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
      />
    </svg>
    {children}
  </div>
);

const Donate = ({
  setShowDonate,
  auth: { isAuthenticated, user },
  profile: { channelid, avatar, firstname, lastname, jobtitle, location },
  users,
  setTextValue,
  showDonate,
  Donation,
  setDonateError,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [cardComplete, setCardComplete] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [mismatchPassword, setMismatchPassword] = useState(
    "*Passwords do not match",
  );
  const [donationUser, setUser] = useState({
    authenticated: isAuthenticated ? true : false,
    username: isAuthenticated ? user.channelid : "",
    DOB: new Date(),
    firstname: isAuthenticated ? user.firstname : "",
    lastname: isAuthenticated ? user.lastname : "",
    email: "",
    jobTitle: isAuthenticated ? user.jobtitle : "",
    location: isAuthenticated
      ? user.location
      : {
          country: "US",
          state: "Alabama",
          city: "",
        },
    password: "",
    confirmPassword: "",
  });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());
  const [billingDetails, setBillingDetails] = useState({
    name: "",
    email: "",
    address: {
      country: "US",
      city: "",
      line1: "",
      line2: "",
      state: "Alabama",
    },
  });
  const [paymentDetails, setPaymentDetails] = useState({
    error: "",
    amount_received: "",
    status: "",
    receipt_email: "",
  });
  const [donateAmount, setDonateAmount] = useState({
    amount: 0,
  });
  const [showPayment, setshowPayment] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (billingDetails.name === "") {
      setAlert("Please enter a name");
    }

    if (billingDetails.email === "") {
      setAlert("Please enter a valid email");
    }

    if (billingDetails.address.line1 === "") {
      setAlert("Please enter your street address");
    }

    if (billingDetails.address.city === "") {
      setAlert("Please enter a city");
    }

    if (billingDetails.address.state === "") {
      setAlert("Please enter a state");
    }

    if (billingDetails.address.country === "") {
      setAlert("Please enter a country");
    }

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    if (cardComplete) {
      setProcessing(true);
    }

    try {
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
        billing_details: billingDetails,
      });

      setProcessing(false);

      if (error) {
        setError(error);
      } else {
        setPaymentMethod(paymentMethod);
      }

      const { id } = paymentMethod;
      const res = await axios.post("https://imelive.tv/donate", {
        amount: donateAmount.amount,
        id,
        billingDetails,
        donationUser,
      });

      if (res.data.msg && res.data.msg !== "") {
        setDonateError(res.data.msg);
      }

      setPaymentDetails({
        error: res.data.msg ? res.data.msg : "",
        amount_received: res.data.payment.amount_received,
        status: res.data.payment.status,
        receipt_email: res.data.payment.receipt_email,
      });

      setshowPayment(true);

      Donation(res.data.supporter, res);
    } catch (error) {
      console.log("Error", error);
    }
  };

  return (
    <Fragment>
      {paymentDetails &&
        paymentDetails.status === "succeeded" &&
        showPayment &&
        !processing && (
          <div className="subscription-overlay">
            <div className="subscription-box-confirmation">
              <i
                className="far fa-times-circle red fa-3x subscription-x"
                onClick={() => {
                  setPaymentDetails({
                    amount_received: "",
                    status: "",
                    receipt_email: "",
                  });
                  setshowPayment(false);
                  setShowDonate(false);
                  setPaymentMethod(null);
                }}
              ></i>
              <div className="subscription-type-container">
                <p className="nav-logo">
                  <RedLogo />
                </p>
                <h1 className="subscription-name red">Payment Successful!</h1>
              </div>
              <div className="sub-grid-three">
                <div className="sub-container">
                  <div className="sub-user">
                    <div className="online-avi-container">
                      <div className="avi-color-border-alt red">
                        <img
                          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                          className="sub-avi"
                        />
                      </div>
                    </div>
                    <div className="online-info">
                      <ul className="user-online-items">
                        <li className="user-online-item">
                          <span className="red name-font bold">
                            {channelid}
                          </span>
                        </li>
                        <li className="user-online-item">{firstname}</li>
                        <li className="user-online-item">{jobtitle}</li>
                        <li className="user-online-item">
                          {location.state}, {location.country}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="sub-container">
                  <div className="sub-section-container">
                    <div className="flex-only">
                      <p className="sub-section red">Donation Amount</p>
                    </div>
                  </div>
                  <div className="subtotal">
                    <p className="total-price white">{`$${
                      paymentDetails.amount_received * 0.01
                    }.00`}</p>
                  </div>
                </div>
              </div>
              <div className="sub-grid">
                <p className="user-request-text white">
                  Thank you for your donation! A receipt has been emailed to the
                  following email address:{" "}
                  <span className="red bold mx-5">
                    {paymentDetails.receipt_email}
                  </span>
                </p>
              </div>
            </div>
          </div>
        )}
      {paymentDetails &&
        paymentDetails.status !== "succeeded" &&
        showPayment &&
        !processing && (
          <div className="subscription-overlay">
            <div className="subscription-box-confirmation">
              <i
                className="far fa-times-circle red fa-3x subscription-x"
                onClick={() => {
                  setPaymentDetails({
                    amount_received: "",
                    status: "",
                    receipt_email: "",
                  });
                  setshowPayment(false);
                  setShowDonate(false);
                  setPaymentMethod(null);
                }}
              ></i>
              <div className="subscription-type-container">
                <p className="nav-logo">
                  <RedLogo />
                </p>
                <h1 className="subscription-name red">Payment Unsuccessful</h1>
              </div>
              <div className="sub-grid-three">
                <div className="sub-container">
                  <div className="sub-user">
                    <div className="online-avi-container">
                      <div className="avi-color-border-alt red">
                        <img
                          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                          className="sub-avi"
                        />
                      </div>
                    </div>
                    <div className="online-info">
                      <ul className="user-online-items">
                        <li className="user-online-item">
                          <span className="red name-font bold">
                            {channelid}
                          </span>
                        </li>
                        <li className="user-online-item">{firstname}</li>
                        <li className="user-online-item">{jobtitle}</li>
                        <li className="user-online-item">
                          {location.state}, {location.country}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="sub-container">
                  <div className="sub-section-container">
                    <div className="flex-only">
                      <p className="sub-section red">Donation Amount</p>
                    </div>
                  </div>
                  {paymentDetails.amount_received !== undefined && (
                    <div className="subtotal">
                      <p className="total-price white">{`$${
                        paymentDetails.amount_received * 0.01
                      }.00`}</p>
                    </div>
                  )}
                  {paymentDetails.error !== "" && (
                    <div className="subtotal">
                      <p className="total-price white">{`$0.00`}</p>
                    </div>
                  )}
                </div>
              </div>
              {paymentDetails.error === "" && (
                <div className="sub-grid">
                  <p className="user-request-text red">
                    Uh-oh! Your payment attempt was unsuccessful. Please check
                    your card information and try again. The status of your
                    payment is:
                    <span className="red bold">{paymentDetails.status}</span>
                  </p>
                </div>
              )}
              {paymentDetails.error !== "" && (
                <div className="sub-grid">
                  <p className="user-request-text red bold">
                    {paymentDetails.error}
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      {!paymentMethod && showDonate && (
        <div className="subscription-overlay">
          <div className="subscription-box">
            {processing && (
              <div className="spinner-overlay">
                <img src={RedSpinner} alt="spinner-position" />
              </div>
            )}
            <i
              className="far fa-times-circle green fa-3x subscription-x"
              onClick={() => setShowDonate(false)}
            ></i>
            <div className="subscription-type-container">
              <p className="nav-logo">
                <GreenLogo />
              </p>
              <h1 className="subscription-name green">Donation to ime</h1>
            </div>
            <div className="subscription-overflow">
              <form
                className="subscription-box-container"
                id="green-scroll"
                onSubmit={(e) => handleSubmit(e)}
              >
                <div className="sub-grid-three">
                  <div className="sub-container">
                    <div className="sub-user">
                      <div className="online-avi-container">
                        <div className="avi-color-border-alt red">
                          <img
                            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                            className="sub-avi"
                          />
                        </div>
                      </div>
                      <div className="online-info">
                        <ul className="user-online-items">
                          <li className="user-online-item">
                            <span className="red name-font bold">
                              {channelid}
                            </span>
                          </li>
                          <li className="user-online-item">{firstname}</li>
                          <li className="user-online-item">{jobtitle}</li>
                          <li className="user-online-item">
                            {location.state}, {location.country}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="sub-container">
                    <div className="sub-section-container">
                      <div className="flex-only-center">
                        <p
                          className={`sub-section ${
                            donateAmount.amount < 20
                              ? "red"
                              : donateAmount.amount > 10000
                                ? "red"
                                : "green"
                          }`}
                        >
                          Subtotal (min: $20 max: $10,000)
                        </p>
                      </div>
                    </div>
                    <div className="">
                      {donateAmount.amount >= 20 && (
                        <p className="white bold subtotal-donate">{`$${
                          donateAmount.amount * 1.0
                        }.00`}</p>
                      )}
                      {donateAmount.amount < 20 && (
                        <p className="red bold subtotal-donate">
                          Please Enter a Valid Amount
                        </p>
                      )}
                      <div className="flex-only-center">
                        <input
                          className={`number-input-donate ${
                            donateAmount.amount < 20
                              ? "add-border red"
                              : "white"
                          } bold`}
                          min={20}
                          max={10000}
                          value={donateAmount.amount}
                          type="number"
                          name="customsubs"
                          onChange={(e) => {
                            e.target.value <= 10000 &&
                              setDonateAmount({
                                ...donateAmount,
                                amount: e.target.value,
                              });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sub-grid">
                  <div className="sub-section-container">
                    <div className="flex-only">
                      <i className="fas fa-star mr-5 fa-lg mt-5 green"></i>
                      <p className="sub-section green">Benefits</p>
                    </div>
                  </div>
                  <div className="grid-rows-donate">
                    <div className="support-type-container grey">
                      <p className="support-type green bold">
                        <span className="support-title">
                          Overwhelming Support
                        </span>{" "}
                        <i class="fa-solid fa-plus green"></i>{" "}
                        <span className="white mr-2">$</span>
                        <span className="white">300</span>
                        <i class="fa-solid fa-angles-up green mx-5"></i>
                      </p>
                      <div className="ime-description">
                        <ul>
                          <li>
                            <span className="green bold">
                              Live Chat Access -{" "}
                            </span>{" "}
                            Text access to the online live chat.
                          </li>
                          <li>
                            <span className="green bold">
                              Community Posts -{" "}
                            </span>{" "}
                            Create and share posts in the ime Community Posts
                            page.
                          </li>
                          <li>
                            <span className="green bold">GIFs - </span>
                            Ability to use GIFs within the live chat and
                            Community Posts.
                          </li>
                          <li>
                            <span className="green bold">"Star" Badge - </span>
                            Special "star" badge unlocked and displayed next to
                            user's name whenever user creates a message in the
                            live chat.
                          </li>
                          <li>
                            <span className="green bold">"1" Badge - </span>
                            Special badge indicated by the number "1" unlocked
                            and displayed next to user's name whenever user
                            creates a message in the live chat. This badge
                            signifies users that are founding supporters.
                          </li>
                          <li>
                            <span className="green bold">
                              Animated Spinning "ime" Logo in Live Chat -{" "}
                            </span>
                            User's name will have a special "ime" logo animation
                            beside their name whenever user creates a message in
                            the live chat.
                          </li>
                          <li>
                            <span className="green bold">
                              Animated Name in Live Chat -{" "}
                            </span>
                            User's name will have a special animation beside
                            their name whenever user creates a message in the
                            live chat.
                          </li>
                          <li>
                            <span className="green bold">
                              ime Discord Access -{" "}
                            </span>
                            Access to ime's Discord. Fun Live Discussion
                            participation and Live Link sessions will be held
                            within Disocrd until full functionality is available
                            within the site.
                          </li>
                          <li>
                            <span className="red bold">
                              *IMPORTANT DISCLAIMER: Donations accumulate as
                              long as the email address used for previous
                              dontation(s) is an EXACT match each time you
                              donate. If you are currently logged in while
                              making a donation, it will be applied to the email
                              address associated with the current logged in
                              account. These benefits are VOIDED if user is not
                              in compliance with the ime Terms of Agreement and
                              Community Guidelines.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="support-type-container grey">
                      <p className="support-type green bold">
                        <span className="support-title">Great Support</span>{" "}
                        <span className="white mr-2">$</span>
                        <span className="white">100</span>
                        <i class="fa-solid fa-minus green mx-10"></i>
                        <span className="white mr-2">$</span>
                        <span className="white">299</span>
                      </p>
                      <div className="ime-description">
                        <ul>
                          <li>
                            <span className="green bold">
                              Live Chat Access -{" "}
                            </span>{" "}
                            Text access to the online live chat.
                          </li>
                          <li>
                            <span className="green bold">
                              Community Posts -{" "}
                            </span>{" "}
                            Create and share posts in the ime Community Posts
                            page.
                          </li>
                          <li>
                            <span className="green bold">GIFs - </span>
                            Ability to use GIFs within the live chat and
                            Community Posts.
                          </li>
                          <li>
                            <span className="green bold">"1" Badge - </span>
                            Special badge indicated by the number "1" unlocked
                            and displayed next to user's name whenever user
                            creates a message in the live chat. This badge
                            signifies users that are founding supporters.
                          </li>
                          <li>
                            <span className="green bold">
                              ime Discord Access -{" "}
                            </span>
                            Access to ime's Discord. Fun Live Discussion
                            participation and Live Link sessions will be held
                            within Disocrd until full functionality is available
                            within the site.
                          </li>
                          <li>
                            <span className="red bold">
                              *IMPORTANT DISCLAIMER: Donations accumulate as
                              long as the email address used for previous
                              dontation(s) is an EXACT match each time you
                              donate. If you are currently logged in while
                              making a donation, it will be applied to the email
                              address associated with the current logged in
                              account. These benefits are VOIDED if user is not
                              in compliance with the ime Terms of Agreement and
                              Community Guidelines.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="support-type-container grey">
                      <p className="support-type green bold">
                        <span className="support-title">Good Support</span>{" "}
                        <span className="white mr-2">$</span>
                        <span className="white">20</span>
                        <i class="fa-solid fa-minus green mx-10"></i>
                        <span className="white mr-2">$</span>
                        <span className="white">99</span>
                      </p>
                      <div className="ime-description">
                        <ul>
                          <li>
                            <span className="green bold">
                              Live Chat Access -{" "}
                            </span>{" "}
                            Text access to the online live chat.
                          </li>
                          <li>
                            <span className="green bold">
                              Community Posts -{" "}
                            </span>{" "}
                            Create and share posts in the ime Community Posts
                            page.
                          </li>
                          <li>
                            <span className="green bold">"1" Badge - </span>
                            Special badge indicated by the number "1" unlocked
                            and displayed next to user's name whenever user
                            creates a message in the live chat. This badge
                            signifies users that are founding supporters.
                          </li>
                          <li>
                            <span className="green bold">
                              ime Discord Access -{" "}
                            </span>
                            Access to ime's Discord. Fun Live Discussion
                            participation and Live Link sessions will be held
                            within Disocrd until full functionality is available
                            within the site.
                          </li>
                          <li>
                            <span className="red bold">
                              *IMPORTANT DISCLAIMER: Donations accumulate as
                              long as the email address used for previous
                              dontation(s) is an EXACT match each time you
                              donate. If you are currently logged in while
                              making a donation, it will be applied to the email
                              address associated with the current logged in
                              account. These benefits are VOIDED if user is not
                              in compliance with the ime Terms of Agreement and
                              Community Guidelines.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="billing">
                  {!isAuthenticated && (
                    <p className="disclaimer-description white">
                      <span className="red bold mr-5">*Note:</span> You are
                      <span className="red bold mx-5">NOT</span>currently logged
                      in. This donation will create a new user account based
                      upon the information entered below. If the email entered
                      below matches any previous donation records, a new account
                      will
                      <span className="red bold mx-5">NOT</span>be created. Be
                      sure you have access to the email you enter below.
                    </p>
                  )}
                  {isAuthenticated && (
                    <p className="disclaimer-description white">
                      <span className="red bold mr-5">*Note:</span>You
                      <span className="red bold mx-5">ARE</span>currently logged
                      in. This donation will be applied to the previous account
                      that is an <span className="red bold mr-5">EXACT</span>
                      match to the "Existing User" info shown below
                      <span className="red bold mx-5">ONLY.</span>If you wish
                      create a new account for this donation, be sure that you
                      are
                      <span className="red bold mx-5">NOT</span>
                      logged in and use an email that is not associated with an
                      active account.
                    </p>
                  )}
                  {isAuthenticated && (
                    <label htmlFor="cardnumber" className="green bold block">
                      *Existing User
                    </label>
                  )}
                  {isAuthenticated ? (
                    <div>
                      <p className="donation-user green bold">
                        <span className="white bold mr-5">
                          Current Logged In User's Username:
                        </span>
                        {user.channelid}
                      </p>
                      <p className="donation-user green bold">
                        <span className="white bold mr-5">
                          Current Logged In User's First Name:
                        </span>
                        {user.firstname}
                      </p>
                      <p className="donation-user green bold">
                        <span className="white bold mr-5">
                          Current Logged In User's Last Name:
                        </span>
                        {user.lastname}
                      </p>
                      <p className="donation-user green bold">
                        <span className="white bold mr-5">
                          Current Logged In User's Job Title:
                        </span>
                        {user.jobtitle}
                      </p>
                      <p className="donation-user green bold">
                        <span className="white bold mr-5">
                          Current Logged In User's Location:
                        </span>
                        {user.location && user.location.state},{" "}
                        {user.location && user.location.country}
                      </p>
                    </div>
                  ) : (
                    <div>
                      {users.length > 0 && (
                        <p className="red bold ">*Username already exists</p>
                      )}
                      {donationUser.username.split("").length > 15 && (
                        <p className="red bold ">*Username length too long</p>
                      )}
                      {donationUser.username.split("").length < 3 &&
                        donationUser.username !== "" && (
                          <p className="red bold ">
                            *Username length too short
                          </p>
                        )}
                      <div className="sub-grid-two">
                        <div className="input-grid">
                          {!isAuthenticated && (
                            <label
                              htmlFor="cardnumber"
                              className="green bold block"
                            >
                              *Create Username: (min: 3 max: 15)
                            </label>
                          )}
                          <div
                            className={`flex-only-container-register ${
                              users && users.length > 0
                                ? "add-border red"
                                : donationUser.username.split("").length < 3 &&
                                    donationUser.username !== ""
                                  ? "add-border red"
                                  : donationUser.username.split("").length >
                                        15 && donationUser.username !== ""
                                    ? "add-border red"
                                    : ""
                            }`}
                          >
                            <FieldUserName
                              name="username"
                              id="name"
                              type="text"
                              placeholder="Create Username"
                              required
                              autoComplete="username"
                              value={donationUser.username}
                              onChange={(e) => {
                                setUser({
                                  ...donationUser,
                                  username: e.target.value,
                                });
                                setTextValue(e.target.value);
                              }}
                            />
                            <p className="white character-counter-DOB">
                              {donationUser.username.split("").length}/{15}{" "}
                              characters
                            </p>
                          </div>
                        </div>
                        <div className="input-grid">
                          <label htmlFor="DOB" className="green bold block">
                            *Date of Birth:
                          </label>
                          {startDate === null && (
                            <p className="red bold">
                              *Please select your date of birth
                            </p>
                          )}
                          <div className="register-input-hidden">
                            <DatePicker
                              className="sub-input"
                              selected={startDate}
                              maxDate={maxDate.setFullYear(
                                endDate.getFullYear() - 13,
                              )}
                              onChange={(date) => {
                                setStartDate(date);
                                setUser({
                                  ...donationUser,
                                  DOB: date,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="sub-grid-two">
                        <div className="input-grid">
                          <label
                            htmlFor="firstname"
                            className="green bold block"
                          >
                            *First Name: (max: 30)
                          </label>
                          {donationUser.firstname.split("").length > 30 && (
                            <p className="red bold">
                              *First Name length too long
                            </p>
                          )}
                          <div className="register-input-hidden">
                            <FieldFirstLastName
                              name="firstname"
                              id="firstname"
                              type="text"
                              placeholder="Enter First Name"
                              required
                              autoComplete="firstname"
                              value={donationUser.firstname}
                              onChange={(e) => {
                                setUser({
                                  ...donationUser,
                                  firstname: e.target.value,
                                });
                              }}
                            />
                            <p className="white character-counter-register">
                              {donationUser.firstname.split("").length}/{30}{" "}
                              characters
                            </p>
                          </div>
                        </div>
                        <div className="input-grid">
                          <label
                            htmlFor="lastname"
                            className="green bold block"
                          >
                            *Last Name: (max: 30)
                          </label>
                          {donationUser.lastname.split("").length > 30 && (
                            <p className="red bold">
                              *Last Name length too long
                            </p>
                          )}
                          <div className="register-input-hidden">
                            <FieldFirstLastName
                              name="lastname"
                              id="lastname"
                              type="text"
                              placeholder="Enter Last Name"
                              autoComplete="lastname"
                              value={donationUser.lastname}
                              onChange={(e) => {
                                setUser({
                                  ...donationUser,
                                  lastname: e.target.value,
                                });
                              }}
                            />
                            <p className="white character-counter-register">
                              {donationUser.lastname.split("").length}/{30}{" "}
                              characters
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="sub-grid-two">
                        <div className="input-grid">
                          <label htmlFor="email" className="green bold block">
                            *Email: (max: 100)
                          </label>
                          {donationUser.email.split("").length > 100 && (
                            <p className="red bold">*Email length too long</p>
                          )}
                          <div className="register-input-hidden">
                            <FieldEmail
                              name="email"
                              id="email"
                              type="email"
                              placeholder="Enter Email"
                              required
                              autoComplete="email"
                              value={donationUser.email}
                              onChange={(e) => {
                                setUser({
                                  ...donationUser,
                                  email: e.target.value,
                                });
                              }}
                            />
                            <p className="white character-counter-register">
                              {donationUser.email.split("").length}/{100}{" "}
                              characters
                            </p>
                          </div>
                        </div>
                        <div className="input-grid">
                          <label
                            htmlFor="jobtitle"
                            className="green bold block"
                          >
                            *Job Title: (max: 50)
                          </label>
                          {donationUser.jobTitle.split("").length > 50 && (
                            <p className="red bold">
                              *Job Title length too long
                            </p>
                          )}
                          <div className="register-input-hidden">
                            <FieldJobTitleStateCity
                              name="jobtitle"
                              id="jobtitle"
                              type="text"
                              placeholder="Enter Job Title"
                              required
                              autoComplete="jobtitle"
                              value={donationUser.jobTitle}
                              onChange={(e) => {
                                setUser({
                                  ...donationUser,
                                  jobTitle: e.target.value,
                                });
                              }}
                            />
                            <p className="white character-counter-register">
                              {donationUser.jobTitle.split("").length}/{50}{" "}
                              characters
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="sub-grid-two">
                        <div className="input-grid">
                          <label
                            htmlFor="password"
                            className="green bold block"
                          >
                            *Password: (min: 7 max: 20):
                          </label>
                          {donationUser.password !== "" &&
                            donationUser.password !==
                              donationUser.confirmPassword && (
                              <label
                                htmlFor="streamkey"
                                className="container-label bold red"
                              >
                                {mismatchPassword}
                              </label>
                            )}
                          {donationUser.confirmPassword !== "" &&
                            donationUser.password === "" &&
                            donationUser.password !==
                              donationUser.confirmPassword && (
                              <label
                                htmlFor="streamkey"
                                className="container-label bold red"
                              >
                                {mismatchPassword}
                              </label>
                            )}
                          {donationUser.password.split("").length < 7 &&
                            donationUser.password !== "" && (
                              <p className="red bold ">
                                *Password length too short
                              </p>
                            )}
                          {donationUser.password.split("").length > 20 && (
                            <p className="red bold ">
                              *Password length too long
                            </p>
                          )}
                          <div className="register-input-hidden">
                            <FieldPasswords
                              name="password"
                              id="password"
                              type="password"
                              placeholder="Enter Password"
                              required
                              autoComplete="password"
                              value={donationUser.password}
                              onChange={(e) => {
                                setUser({
                                  ...donationUser,
                                  password: e.target.value,
                                });
                              }}
                            />
                            <p className="white character-counter-register">
                              {donationUser.password.split("").length}/{20}{" "}
                              characters
                            </p>
                          </div>
                        </div>
                        <div className="input-grid">
                          <label
                            htmlFor="confirmPassword"
                            className="green bold block"
                          >
                            *Confirm Password: (min: 7 max: 20):
                          </label>
                          {donationUser.confirmPassword !== "" &&
                            donationUser.confirmPassword !==
                              donationUser.password && (
                              <label
                                htmlFor="streamkey"
                                className="container-label bold red"
                              >
                                {mismatchPassword}
                              </label>
                            )}
                          {donationUser.confirmPassword === "" &&
                            donationUser.password !==
                              donationUser.confirmPassword && (
                              <label
                                htmlFor="streamkey"
                                className="container-label bold red"
                              >
                                {mismatchPassword}
                              </label>
                            )}
                          {donationUser.confirmPassword.split("").length < 7 &&
                            donationUser.confirmPassword !== "" && (
                              <p className="red bold ">
                                *Password length too short
                              </p>
                            )}
                          {donationUser.confirmPassword.split("").length >
                            20 && (
                            <p className="red bold ">
                              *Password length too long
                            </p>
                          )}
                          <div className="register-input-hidden">
                            <FieldPasswords
                              name="confirmPassword"
                              id="confirmPassword"
                              min={7}
                              max={20}
                              type="password"
                              placeholder="Confirm Password"
                              required
                              autoComplete="confirmPassword"
                              value={donationUser.confirmPassword}
                              onChange={(e) => {
                                setUser({
                                  ...donationUser,
                                  confirmPassword: e.target.value,
                                });
                              }}
                            />
                            <p className="white character-counter-register">
                              {donationUser.confirmPassword.split("").length}/
                              {20} characters
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="sub-grid-three-alt-subscribe">
                        <div className="input-grid">
                          <label htmlFor="country" className="green bold block">
                            *Country
                          </label>
                          <select
                            name="country"
                            id="country"
                            type="country"
                            required
                            value={donationUser.location.country}
                            onChange={(e) => {
                              const Location = { ...donationUser };
                              Location.location.country = e.target.value;
                              setUser(Location);
                            }}
                          >
                            <option value="US">US</option>
                            <option value="AU">AU</option>
                            <option value="AT">AT</option>
                            <option value="BE">BE</option>
                            <option value="BR">BR</option>
                            <option value="BG">BG</option>
                            <option value="CA">CA</option>
                            <option value="CY">CY</option>
                            <option value="CZ">CZ</option>
                            <option value="DK">DK</option>
                            <option value="EE">EE</option>
                            <option value="FI">FI</option>
                            <option value="FR">FR</option>
                            <option value="DE">DE</option>
                            <option value="GR">GR</option>
                            <option value="HK">HK</option>
                            <option value="HU">HU</option>
                            <option value="IN">IN</option>
                            <option value="IE">IE</option>
                            <option value="IT">IT</option>
                            <option value="JP">JP</option>
                            <option value="LV">LV</option>
                            <option value="LT">LT</option>
                            <option value="LU">LU</option>
                            <option value="MY">MY</option>
                            <option value="MT">MT</option>
                            <option value="MX">MX</option>
                            <option value="NL">NL</option>
                            <option value="NZ">NZ</option>
                            <option value="NO">NO</option>
                            <option value="PL">PL</option>
                            <option value="PT">PT</option>
                            <option value="RO">RO</option>
                            <option value="SG">SG</option>
                            <option value="SK">SK</option>
                            <option value="SI">SI</option>
                            <option value="ES">ES</option>
                            <option value="SE">SE</option>
                            <option value="CH">CH</option>
                            <option value="AE">AE</option>
                            <option value="GB">GB</option>
                          </select>
                        </div>
                        {donationUser.location.country === "US" && (
                          <div className="input-grid">
                            <label htmlFor="state" className="green bold block">
                              *State
                            </label>
                            <select
                              name="state"
                              id="state"
                              type="state"
                              required
                              value={donationUser.location.state}
                              onChange={(e) => {
                                const Location = { ...donationUser };
                                Location.location.state = e.target.value;
                                setUser(Location);
                              }}
                            >
                              <option value="Alabama">Alabama</option>
                              <option value="Alaska">Alaska</option>
                              <option value="Arizona">Arizona</option>
                              <option value="Arkansas">Arkansas</option>
                              <option value="California">California</option>
                              <option value="Colorado">Colorado</option>
                              <option value="Connecticut">Connecticut</option>
                              <option value="Delaware">Delaware</option>
                              <option value="Florida">Florida</option>
                              <option value="Georgia">Georgia</option>
                              <option value="Hawaii">Hawaii</option>
                              <option value="Idaho">Idaho</option>
                              <option value="Illinois">Illinois</option>
                              <option value="Indiana">Indiana</option>
                              <option value="Iowa">Iowa</option>
                              <option value="Kansas">Kansas</option>
                              <option value="Kentucky">Kentucky</option>
                              <option value="Louisiana">Louisiana</option>
                              <option value="Maine">Maine</option>
                              <option value="Maryland">Maryland</option>
                              <option value="Massachusetts">
                                Massachusetts
                              </option>
                              <option value="Michigan">Michigan</option>
                              <option value="Minnesota">Minnesota</option>
                              <option value="Mississippi">Mississippi</option>
                              <option value="Missouri">Missouri</option>
                              <option value="Montana">Montana</option>
                              <option value="Nebraska">Nebraska</option>
                              <option value="Nevada">Nevada</option>
                              <option value="New Hampshire">
                                New Hampshire
                              </option>
                              <option value="New Jersey">New Jersey</option>
                              <option value="New Mexico">New Mexico</option>
                              <option value="New York">New York</option>
                              <option value="North Carolina">
                                North Carolina
                              </option>
                              <option value="North Dakota">North Dakota</option>
                              <option value="Ohio">Ohio</option>
                              <option value="Oklahoma">Oklahoma</option>
                              <option value="Oregon">Oregon</option>
                              <option value="Pennsylvania">Pennsylvania</option>
                              <option value="Rhode Island">Rhode Island</option>
                              <option value="South Carolina">
                                South Carolina
                              </option>
                              <option value="South Dakota">South Dakota</option>
                              <option value="Tennessee">Tennessee</option>
                              <option value="Texas">Texas</option>
                              <option value="Utah">Utah</option>
                              <option value="Vermont">Vermont</option>
                              <option value="Virginia">Virginia</option>
                              <option value="Washington">Washington</option>
                              <option value="West Virginia">
                                West Virginia
                              </option>
                              <option value="Wisconsin">Wisconsin</option>
                              <option value="Wyoming">Wyoming</option>
                            </select>
                          </div>
                        )}
                        {donationUser.location.country !== "US" && (
                          <div className="input-grid">
                            <label htmlFor="state" className="green bold block">
                              *State: (max: 50)
                            </label>
                            {donationUser.location.state.split("").length >
                              50 && (
                              <p className="red bold">
                                *State Name length too long
                              </p>
                            )}
                            <div className="register-input-hidden">
                              <FieldJobTitleStateCity
                                name="state"
                                id="state"
                                type="state"
                                placeholder="Enter State"
                                required
                                autoComplete="state"
                                value={donationUser.location.state}
                                onChange={(e) => {
                                  const Location = { ...donationUser };
                                  Location.location.state = e.target.value;
                                  setUser(Location);
                                }}
                              />
                              <p className="white character-counter-register">
                                {donationUser.location.state.split("").length}/
                                {50} characters
                              </p>
                            </div>
                          </div>
                        )}
                        <div className="input-grid">
                          <label htmlFor="city" className="green bold block">
                            *City: (max: 50)
                          </label>
                          {donationUser.location.city.split("").length > 50 && (
                            <p className="red bold">
                              *City Name length too long
                            </p>
                          )}
                          <div className="register-input-hidden">
                            <FieldJobTitleStateCity
                              name="city"
                              id="city"
                              type="text"
                              placeholder="Enter City"
                              autoComplete="city"
                              required
                              value={donationUser.location.city}
                              onChange={(e) => {
                                const Location = { ...donationUser };
                                Location.location.city = e.target.value;
                                setUser(Location);
                              }}
                            />
                            <p className="white character-counter-register">
                              {donationUser.location.city.split("").length}/{50}{" "}
                              characters
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="sub-section-container-alt-m">
                    <div className="flex-only">
                      <p className="sub-section green">Payment Methods</p>
                    </div>
                    <div className="flex-only">
                      <i className="fab fa-cc-visa mr-5 mt-5 fa-2x white"></i>
                      <i className="fab fa-cc-mastercard mr-5 mt-5 fa-2x white"></i>
                      <i className="fab fa-cc-jcb mr-5 mt-5 fa-2x white"></i>
                      <i className="fab fa-cc-discover mr-5 mt-5 fa-2x white"></i>
                      <i className="fab fa-cc-diners-club mr-5 mt-5 fa-2x white"></i>
                      <i className="fab fa-cc-amex mt-5 fa-2x white"></i>
                    </div>
                  </div>
                  <div className="sub-section-container-alt-m">
                    <div className="flex-only">
                      <p className="sub-section green">Card Information</p>
                    </div>
                  </div>
                  <div className="sub-grid-two">
                    <div className="input-grid">
                      <label htmlFor="name" className="green bold block">
                        *Name on Card
                      </label>
                      {billingDetails.name === "" && <Alert />}
                      <Field
                        name="name"
                        id="name"
                        type="text"
                        placeholder="Enter Name on Card"
                        required
                        autoComplete="name"
                        value={billingDetails.name}
                        onChange={(e) => {
                          setBillingDetails({
                            ...billingDetails,
                            name: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="input-grid">
                      <label htmlFor="email" className="green bold block">
                        *Email Address
                      </label>
                      {billingDetails.email === "" && <Alert />}
                      <Field
                        name="email"
                        id="email"
                        type="email"
                        placeholder="Enter Email Address"
                        required
                        autoComplete="email"
                        value={billingDetails.email}
                        onChange={(e) => {
                          setBillingDetails({
                            ...billingDetails,
                            email: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="input-grid">
                      <label htmlFor="cardnumber" className="green bold block">
                        *Card Number
                      </label>
                      <CardField
                        onChange={(e) => {
                          setError(e.error);
                          setCardComplete(e.complete);
                        }}
                      />
                    </div>
                  </div>
                  <div className="sub-grid-two">
                    <div className="input-grid">
                      <label htmlFor="line1" className="green bold block">
                        *Billing Address Line 1
                      </label>
                      {billingDetails.address.line1 === "" && <Alert />}
                      <Field
                        name="line1"
                        id="line1"
                        type="text"
                        placeholder="Enter Street Address"
                        required
                        autoComplete="line1"
                        value={billingDetails.address.line1}
                        onChange={(e) => {
                          const billingdetails = { ...billingDetails };
                          billingdetails.address.line1 = e.target.value;
                          setBillingDetails(billingdetails);
                        }}
                      />
                    </div>
                    <div className="input-grid">
                      <label htmlFor="line2" className="green bold block">
                        Billing Address Line 2
                      </label>
                      <Field
                        name="line2"
                        id="line2"
                        type="text"
                        placeholder="Enter Suite, Apt, Unit"
                        autoComplete="line2"
                        value={billingDetails.address.line2}
                        onChange={(e) => {
                          const billingdetails = { ...billingDetails };
                          billingdetails.address.line2 = e.target.value;
                          setBillingDetails(billingdetails);
                        }}
                      />
                    </div>
                  </div>
                  <div className="sub-grid-three-alt-subscribe">
                    <div className="input-grid">
                      <label htmlFor="country" className="green bold block">
                        *Country
                      </label>
                      {billingDetails.address.country === "" && <Alert />}
                      <select
                        name="country"
                        id="country"
                        type="country"
                        required
                        value={billingDetails.address.country}
                        onChange={(e) => {
                          const billingdetails = { ...billingDetails };
                          billingdetails.address.country = e.target.value;
                          setBillingDetails(billingdetails);
                        }}
                      >
                        <option value="US">US</option>
                        <option value="AU">AU</option>
                        <option value="AT">AT</option>
                        <option value="BE">BE</option>
                        <option value="BR">BR</option>
                        <option value="BG">BG</option>
                        <option value="CA">CA</option>
                        <option value="CY">CY</option>
                        <option value="CZ">CZ</option>
                        <option value="DK">DK</option>
                        <option value="EE">EE</option>
                        <option value="FI">FI</option>
                        <option value="FR">FR</option>
                        <option value="DE">DE</option>
                        <option value="GR">GR</option>
                        <option value="HK">HK</option>
                        <option value="HU">HU</option>
                        <option value="IN">IN</option>
                        <option value="IE">IE</option>
                        <option value="IT">IT</option>
                        <option value="JP">JP</option>
                        <option value="LV">LV</option>
                        <option value="LT">LT</option>
                        <option value="LU">LU</option>
                        <option value="MY">MY</option>
                        <option value="MT">MT</option>
                        <option value="MX">MX</option>
                        <option value="NL">NL</option>
                        <option value="NZ">NZ</option>
                        <option value="NO">NO</option>
                        <option value="PL">PL</option>
                        <option value="PT">PT</option>
                        <option value="RO">RO</option>
                        <option value="SG">SG</option>
                        <option value="SK">SK</option>
                        <option value="SI">SI</option>
                        <option value="ES">ES</option>
                        <option value="SE">SE</option>
                        <option value="CH">CH</option>
                        <option value="AE">AE</option>
                        <option value="GB">GB</option>
                      </select>
                    </div>
                    {billingDetails.address.country === "US" && (
                      <div className="input-grid">
                        <label htmlFor="state" className="green bold block">
                          *State
                        </label>
                        {billingDetails.address.state === "" && <Alert />}
                        <select
                          name="state"
                          id="state"
                          type="state"
                          required
                          value={billingDetails.address.state}
                          onChange={(e) => {
                            const billingdetails = { ...billingDetails };
                            billingdetails.address.state = e.target.value;
                            setBillingDetails(billingdetails);
                          }}
                        >
                          <option value="Alabama">Alabama</option>
                          <option value="Alaska">Alaska</option>
                          <option value="Arizona">Arizona</option>
                          <option value="Arkansas">Arkansas</option>
                          <option value="California">California</option>
                          <option value="Colorado">Colorado</option>
                          <option value="Connecticut">Connecticut</option>
                          <option value="Delaware">Delaware</option>
                          <option value="Florida">Florida</option>
                          <option value="Georgia">Georgia</option>
                          <option value="Hawaii">Hawaii</option>
                          <option value="Idaho">Idaho</option>
                          <option value="Illinois">Illinois</option>
                          <option value="Indiana">Indiana</option>
                          <option value="Iowa">Iowa</option>
                          <option value="Kansas">Kansas</option>
                          <option value="Kentucky">Kentucky</option>
                          <option value="Louisiana">Louisiana</option>
                          <option value="Maine">Maine</option>
                          <option value="Maryland">Maryland</option>
                          <option value="Massachusetts">Massachusetts</option>
                          <option value="Michigan">Michigan</option>
                          <option value="Minnesota">Minnesota</option>
                          <option value="Mississippi">Mississippi</option>
                          <option value="Missouri">Missouri</option>
                          <option value="Montana">Montana</option>
                          <option value="Nebraska">Nebraska</option>
                          <option value="Nevada">Nevada</option>
                          <option value="New Hampshire">New Hampshire</option>
                          <option value="New Jersey">New Jersey</option>
                          <option value="New Mexico">New Mexico</option>
                          <option value="New York">New York</option>
                          <option value="North Carolina">North Carolina</option>
                          <option value="North Dakota">North Dakota</option>
                          <option value="Ohio">Ohio</option>
                          <option value="Oklahoma">Oklahoma</option>
                          <option value="Oregon">Oregon</option>
                          <option value="Pennsylvania">Pennsylvania</option>
                          <option value="Rhode Island">Rhode Island</option>
                          <option value="South Carolina">South Carolina</option>
                          <option value="South Dakota">South Dakota</option>
                          <option value="Tennessee">Tennessee</option>
                          <option value="Texas">Texas</option>
                          <option value="Utah">Utah</option>
                          <option value="Vermont">Vermont</option>
                          <option value="Virginia">Virginia</option>
                          <option value="Washington">Washington</option>
                          <option value="West Virginia">West Virginia</option>
                          <option value="Wisconsin">Wisconsin</option>
                          <option value="Wyoming">Wyoming</option>
                        </select>
                      </div>
                    )}
                    {billingDetails.address.country !== "US" && (
                      <div className="input-grid">
                        <label htmlFor="state" className="green bold block">
                          *State
                        </label>
                        {billingDetails.address.state === "" && <Alert />}
                        <Field
                          name="state"
                          id="state"
                          type="state"
                          placeholder="Enter State"
                          required
                          autoComplete="state"
                          value={billingDetails.address.state}
                          onChange={(e) => {
                            setBillingDetails({
                              ...billingDetails,
                              address: { state: e.target.value },
                            });
                          }}
                        />
                      </div>
                    )}
                    <div className="input-grid">
                      <label htmlFor="city" className="green bold block">
                        *City
                      </label>
                      {billingDetails.address.city === "" && <Alert />}
                      <Field
                        name="city"
                        id="city"
                        type="text"
                        placeholder="Enter City"
                        autoComplete="city"
                        required
                        value={billingDetails.address.city}
                        onChange={(e) => {
                          const billingdetails = { ...billingDetails };
                          billingdetails.address.city = e.target.value;
                          setBillingDetails(billingdetails);
                        }}
                      />
                    </div>
                  </div>
                  {error && <ErrorMessage>{error.message}</ErrorMessage>}
                  {isAuthenticated &&
                    donateAmount.amount >= 20 &&
                    donateAmount.amount <= 10000 &&
                    billingDetails.name !== "" &&
                    billingDetails.address.city !== "" &&
                    billingDetails.address.line1 !== "" &&
                    billingDetails.address.country !== "" &&
                    billingDetails.email !== "" && (
                      <SubmitButton
                        processing={processing}
                        error={error}
                        disabled={!stripe}
                        onSubmit={(e) => handleSubmit(e)}
                      >
                        <i className="fa-solid fa-circle-dollar-to-slot mr-5"></i>
                        Confirm and Donate {`$${donateAmount.amount * 1.0}.00`}
                      </SubmitButton>
                    )}
                  {!isAuthenticated &&
                    donateAmount.amount >= 20 &&
                    donateAmount.amount <= 10000 &&
                    billingDetails.name !== "" &&
                    billingDetails.address.city !== "" &&
                    billingDetails.address.line1 !== "" &&
                    billingDetails.address.country !== "" &&
                    billingDetails.email !== "" &&
                    donationUser.username !== "" &&
                    startDate !== null &&
                    donationUser.email !== "" &&
                    donationUser.firstname !== "" &&
                    donationUser.lastname !== "" &&
                    donationUser.jobTitle !== "" &&
                    donationUser.location.city !== "" &&
                    donationUser.location.state !== "" &&
                    donationUser.location.country !== "" &&
                    donationUser.password !== "" &&
                    donationUser.confirmPassword !== "" &&
                    users.length <= 0 && (
                      <SubmitButton
                        processing={processing}
                        error={error}
                        disabled={!stripe}
                        onSubmit={(e) => handleSubmit(e)}
                      >
                        <i className="fa-solid fa-circle-dollar-to-slot mr-5"></i>
                        Confirm and Donate {`$${donateAmount.amount * 1.0}.00`}
                      </SubmitButton>
                    )}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(Donate);
